import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

import decisionsReducer from './db/decisions';
import modalReducer from './ui/modal';
import userReducer from './db/user';
export default history =>
  combineReducers({
    form: formReducer,
    router: connectRouter(history),
    db: combineReducers({
      decisions: decisionsReducer,
      users: userReducer
    }),
    ui: combineReducers({
      modals: modalReducer
    })
  });
